var _circle, _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonusPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#F5FAFC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 12.0596,
    ry: 12.0596,
    transform: "matrix(1 0 0 -1 57.79 49.4443)",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1652 52.3152C64.1652 44.8055 58.0773 38.7177 50.5676 38.7177C43.0579 38.7177 36.9701 44.8055 36.9701 52.3152C36.9701 59.8249 43.0579 65.9128 50.5676 65.9128C58.0773 65.9128 64.1652 59.8249 64.1652 52.3152Z",
    stroke: "#011E29",
    strokeWidth: 2.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1576 66.8415C46.1576 68.6283 47.6061 70.0768 49.3929 70.0768H51.7408C53.5277 70.0768 54.9762 68.6283 54.9762 66.8415V65.8016C52.2848 67.4435 48.849 67.4435 46.1576 65.8016V66.8415Z",
    stroke: "#011E29",
    strokeWidth: 2.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5742 72L50.5742 71.4121",
    stroke: "#011E29",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1821 38.7873L30.4961 36.8008",
    stroke: "#011E29",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.267 36.5664L67.6724 38.6623",
    stroke: "#011E29",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 30L50.5001 26.8",
    stroke: "#011E29",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusPackages);
export default __webpack_public_path__ + "static/media/bonus-packages.1f2e390c84dc249de05b84a69ac9143e.svg";
export { ForwardRef as ReactComponent };